(function(api) {
	api.GetDjelatOdobrava = GetDjelatOdobrava;
	api.GetDjelatTestira = GetDjelatTestira;
	api.GetUgovorListByPartnerId = GetUgovorListByPartnerId;
	api.GetSateUgovora = GetSateUgovora;
	api.GetMinDatumAktivnihUgovoraByPartnerId = GetMinDatumAktivnihUgovoraByPartnerId;
	api.GetUgovorFields = GetUgovorFields;
	api.GetUgovoreniModuliFields = GetUgovoreniModuliFields;
	api.GetUgovorSatiFields = GetUgovorSatiFields;
	api.GetPrProjektSFields = GetPrProjektSFields;
	api.PosaoKopiraj = PosaoKopiraj;
	api.PosaoObrisi = PosaoObrisi;
	api.PosaoTrObrisi = PosaoTrObrisi;
	api.DohvatiSpajanjeInfo = DohvatiSpajanjeInfo;
	api.DohvatiZadanoSpajanje = DohvatiZadanoSpajanje;
	api.DohvatiAplikacijaOvlastenja = DohvatiAplikacijaOvlastenja;
	api.DohvatiPoslovePanel = DohvatiPoslovePanel;
	api.DjelatGPosaoGetSatiGPosao = DjelatGPosaoGetSatiGPosao;
	api.DjelatGPosaoGetSatiDjelat = DjelatGPosaoGetSatiDjelat;
	api.DjelatGPosaoObrisi = DjelatGPosaoObrisi;
	api.GetDjelatGPosaoFields = GetDjelatGPosaoFields;
	api.GetPrProjektFields = GetPrProjektFields;
	api.PrProjektSObrisi = PrProjektSObrisi;
	api.BrojPoslovaSaGrupomZaRazvoj = BrojPoslovaSaGrupomZaRazvoj;
	api.GetMaxDovrsenostGPosaoRazvoj = GetMaxDovrsenostGPosaoRazvoj;
	api.PlanSatiZaDjelatIGPosaoRaz = PlanSatiZaDjelatIGPosaoRaz;
	api.DjelatGPosaoKopiraj = DjelatGPosaoKopiraj;
	api.GetVrijemePrikaza = GetVrijemePrikaza;
	api.GetBrojObavijesti = GetBrojObavijesti;	
	api.ClearObavijesti = ClearObavijesti;
	api.ClearObavijestZaPosaoDjelat = ClearObavijestZaPosaoDjelat;
	api.GetParOsobaAktivnaDo = GetParOsobaAktivnaDo;
	api.GetKalendarDjelat = GetKalendarDjelat;
	api.GetKalendarEvents = GetKalendarEvents;
	api.GetOdsutniDataSet = GetOdsutniDataSet;
	api.OmoguciUpisBrojaPodposlovaIPrograma = OmoguciUpisBrojaPodposlovaIPrograma;
	api.PRedlozakObrisi = PPredlozakObrisi;
	api.PPredlozakSObrisi = PPredlozakSObrisi;
	api.GetPPredlozakSFields = GetPPredlozakSFields;
	api.IzracunajRedniBrojPodposla = IzracunajRedniBrojPodposla;
	api.PPredlozakById = PPredlozakById;
	api.GetDjelatPodsjetnik = GetDjelatPodsjetnik;
	api.IzmijeniDjelatPodsjetnik = IzmijeniDjelatPodsjetnik;
	api.PredloziLozinku = PredloziLozinku;	
	api.KriptirajLozinkuUClipboard = KriptirajLozinkuUClipboard;
	api.MogucNoviPosaoZaPP = MogucNoviPosaoZaPP;
	api.GenerateKontoPass = GenerateKontoPass;
    api.GetParOsobaEmailFields = GetParOsobaEmailFields;
    api.ProgramiOsobeNaMailingListi = ProgramiOsobeNaMailingListi;
    api.PratimDodajPosao = PratimDodajPosao;
    api.PratimUkloniPosao = PratimUkloniPosao;
    api.GetInfoNaPanelZaPartnera = GetInfoNaPanelZaPartnera;	
	api.GetDjelatOdobravaData = GetDjelatOdobravaData;
	api.GetDjelatTestiraData = GetDjelatTestiraData;
	
	function GetDjelatOdobrava(aplikacija) {
		return $.dsDirectCall({ 
			method: "GetDjelatOdobrava",
			params: [aplikacija]
		});
	}
	
	function GetDjelatTestira(aplikacija) {
		return $.dsDirectCall({ 
			method: "GetDjelatTestira", 
			params: [aplikacija]
		});
	}
	
	function GetUgovorFields() {
		return $.dsDirectCall({ 
			method: "GetUgovorFields"
		});
	}
	
	function GetUgovoreniModuliFields(partner) {
		return $.dsDirectCall({ 
			method: "GetUgovoreniModuliFields",
			params: [partner]
		});
	}
	
	function GetUgovorSatiFields() {
		return $.dsDirectCall({
			method: "GetUgovorSatiFields"
		});
	}
	
	function GetPrProjektSFields() {
		return $.dsDirectCall({ 
			method: "GetPrProjektSFields"
		});
	}
	
	function DohvatiSpajanjeInfo(spajanjeId,posaoId){
	      return $.dsDirectCall({ 
                method: "GetSpajanjeInfo",
                params: [spajanjeId, posaoId],
            });    
	}
	
	function DohvatiZadanoSpajanje(partnerId){
	  return $.dsDirectCall({ 
                method: "GetZadanoSpajanje",
                params: [partnerId],
            });
	}
	
	function PredloziLozinku(){
	  return $.dsDirectCall({ 
                method: "PredloziLozinku"
            });
	}
	function KriptirajLozinkuUClipboard(lozinka){
	  return $.dsDirectCall({ 
                method: "KriptirajLozinkuUClipboard",
                params: [lozinka],
            });
	}
	
	function DohvatiAplikacijaOvlastenja(appId,partnerId){
		if ((partnerId == undefined) || (partnerId == ''))  partnerId = 0;
	       return $.dsDirectCall({ 
                method: "GetAplikacijaOvlastenjaInfo",
                params: [appId, partnerId],  
	       });
	}
	
	
	function GetUgovorListByPartnerId(partner) {
		return $.dsDirectCall({
            method: "GetUgovorListByPartnerId",
            params: [partner]
     	});
	}
	
	function GetSateUgovora(partner, datumOd, datumDo, kumulativno) {
		return $.dsDirectCall({
            method: "GetSateUgovora",
            params: [partner, datumOd, datumDo, kumulativno]
     	});
	}
	
	function GetMinDatumAktivnihUgovoraByPartnerId(partner) {
		return $.dsDirectCall({
            method: "GetMinDatumAktivnihUgovoraByPartnerId",
            params: [ partner ]
     	});
	}	
	
	function PosaoKopiraj(posao) {
		return $.dsDirectCall({
            method: "PosaoKopiraj",
            params: [posao]
        });
	}
	
	function PosaoObrisi(posao) {
		return $.dsDirectCall({
            method: "PosaoObrisi",
            params: [posao]
        });
  	}
  	
  	function PosaoTrObrisi(posaoTr) {
  		return $.dsDirectCall({
            method: "PosaoTrObrisi",
            params: [posaoTr]
        });	
  	}
  	
  	function DohvatiPoslovePanel(tip) {
		return $.dsDirectCall({
            method: "GetPosaoPanelDataSet",
            params: [{tip:tip}]
        });
	};
	
	function DjelatGPosaoGetSatiGPosao(gPosao, djelatGPosao){
		return $.dsDirectCall({ 
	        method: "DjelatGPosaoGetSatiGPosao",
	        params: [{gPosao: gPosao, djelatGPosao: djelatGPosao}]
        });	
	};
	
	function DjelatGPosaoGetSatiDjelat(djelat, datum, djelatGPosao){
		return $.dsDirectCall({
			method: "DjelatGPosaoGetSatiDjelat",
			params: [{djelat: djelat,  datum: datum, djelatGPosao:  djelatGPosao}]
		});
	}
	
  	function DjelatGPosaoObrisi(djelatgposao) {
  		return $.dsDirectCall({
            method: "DjelatGPosaoObrisi",
            params: [djelatgposao]
        });	
  	}
  
 	function GetDjelatGPosaoFields(gPosao) {
		return $.dsDirectCall({ 
			method: "GetDjelatGPosaoFields",
			params: [gPosao]
		});
	}	
  	
  	function  GetPrProjektFields(gPosao){
  	  	return $.dsDirectCall({
            method: "GetPrProjektFields",
            params: [gPosao]
        });	
  	}
  	
    function  PrProjektSObrisi(prProjekts){
  	  	return $.dsDirectCall({
            method: "PrProjektSObrisi",
            params: [prProjekts]
        });	
  	}
  	
  	function BrojPoslovaSaGrupomZaRazvoj(gPosaoRaz){
  		return $.dsDirectCall({
  			method: "BrojPoslovaSaGrupomZaRazvoj",
  			params: [gPosaoRaz]
  		});
  	}
  	
  	function GetMaxDovrsenostGPosaoRazvoj(gPosaoRaz){
  		return $.dsDirectCall({
  			method: "GetMaxDovrsenostGPosaoRazvoj",
  			params: [gPosaoRaz]
  		});
  	}
  	
  	function PlanSatiZaDjelatIGPosaoRaz(djelat, gPosaoRaz){
  		return $.dsDirectCall({
  			method: "PlanSatiZaDjelatIGPosaoRaz",
  			params: [djelat, gPosaoRaz]
  		});
  	}
  	
  	function DjelatGPosaoKopiraj(djelatGPosao){
  		return $.dsDirectCall({
  			method: "DjelatGPosaoKopiraj",
  			params: [ djelatGPosao ]
  		});
  	}
  	
  	 function  PPredlozakObrisi(predlozak){
  	  	return $.dsDirectCall({
            method: "PPredlozakObrisi",
            params: [ predlozak ]
        });	
  	}
  	
  	 function  PPredlozakSObrisi(predlozak){
  	  	return $.dsDirectCall({
            method: "PPredlozakSObrisi",
            params: [ predlozak ]
        });	
  	}
  	
  	 function  GetPPredlozakSFields(){
  	  	return $.dsDirectCall({
            method: "GetPPredlozakSFields"
            
        });	
  	}
  	
  	function  IzracunajRedniBrojPodposla(predlozak){
  	  	return $.dsDirectCall({
            method: "IzracunajRedniBrojPodposla",
            params: [ predlozak ]
            
        });	
  	}
  	
  	function PPredlozakById(predlozak){
  			return $.dsDirectCall({
            method: "PPredlozakById",
            params: [ predlozak ]
            
        });	
  	}
  	
  	function OmoguciUpisBrojaPodposlovaIPrograma(predlozak){
		return $.dsDirectCall({
			method: "OmoguciUpisBrojaPodposlovaIPrograma",
			params: [ predlozak ]
		});
	}
  	
  	function GetVrijemePrikaza(posao, djelat){
  		return $.dsDirectCall({
  			method: "GetVrijemePrikaza",
  			params: [ posao, djelat ]
  		});
  	}  	
  	
  	function GetBrojObavijesti(djelat){
  		return $.dsDirectCall({
  			method: "GetBrojObavijesti",
			params: [ djelat ],
			errorOverride: true
  		});
  	}
  		
  	function ClearObavijesti(djelat){
  		return $.dsDirectCall({
  			method: "ClearObavijesti",
  			params: [ djelat ]
  		});  				
  	} 
  	
  	function ClearObavijestZaPosaoDjelat(posao, djelat){
  		return $.dsDirectCall({
  			method: "ClearObavijestZaPosaoDjelat",
  			params: [ posao, djelat ]
  		});  	
  	} 
  	
  	function GetParOsobaAktivnaDo(partner, parosoba){
  		return $.dsDirectCall({
  			method: "GetParOsobaAktivnaDo",
  			params: [ partner, parosoba ]
  		});
	  } 
	  
  	function GetKalendarEvents(params){
		return $.dsDirectCall({
			method: "GetKalendarEvents",
			params: [ params ]
		});
	} 	  

	function GetKalendarDjelat(params){
		return $.dsDirectCall({
			method: "GetKalendarDjelat",
			params: [ params ]
		});
	} 
	
	function GetOdsutniDataSet(params){
		return $.dsDirectCall({
			method: "ek/GetOdsutniDataSet",
			params: [ params ]	
		});
	}
	
	function GetDjelatPodsjetnik(djelat){
		return $.dsDirectCall({
			method: "ek/GetDjelatPodsjetnik",
			params: [ djelat ]	
		});
	}
	
	function IzmijeniDjelatPodsjetnik(djelat, podsjetnik){
		return $.dsDirectCall({
			method: "ek/IzmijeniDjelatPodsjetnik",
			params: [ djelat, podsjetnik ]	
		});
	}
	
	function MogucNoviPosaoZaPP(gPosao, prProjekt){
	    return $.dsDirectCall({
            method: "ek/MogucNoviPosaoZaPP",
            params: [ gPosao, prProjekt ] 
	    });
	}
        
    function GenerateKontoPass() {
        return $.dsDirectCall({ 
            method: "GenerateKontoPass"
        });
    }

    function GetParOsobaEmailFields(partner) {
        return $.dsDirectCall({ 
            method: "GetParOsobaEmailFields",
            params: [partner]
        });
    }
    
    function ProgramiOsobeNaMailingListi(partner, parOsoba) {
        return $.dsDirectCall({ 
            method: "ProgramiOsobeNaMailingListi",
            params: [partner, parOsoba]
        });
    }

	function PratimDodajPosao(posaoID) {
		return $.dsDirectCall({ 
			method: "PratimDodajPosao",
			params: [posaoID]
		});
	}
	
	function PratimUkloniPosao(posaoID) {
		return $.dsDirectCall({ 
			method: "PratimUkloniPosao",
			params: [posaoID]
		});
	}
	
	function GetInfoNaPanelZaPartnera(partnerID) {
		return $.dsDirectCall({ 
			method: "GetInfoNaPanelZaPartnera",
			params: [partnerID]
		});
	}

	function GetDjelatOdobravaData(aplikacija, aktivan) {
		return $.dsDirectCall({ 
			method: "GetDjelatOdobravaData",
			params: [aplikacija, aktivan]
		});
	}
	
	function GetDjelatTestiraData(aplikacija, aktivan) {
		return $.dsDirectCall({ 
			method: "GetDjelatTestiraData", 
			params: [aplikacija, aktivan]
		});
	}

} (konto.ek.api = {}));